import { format } from "date-fns";

export const infoOptions = [
  {
    label: "No Email",
    color: "#1F1F1F",
    apiKey: "not_filled"
  },
  {
    label: "Pending Approval",
    color: "#E9A30C",
    apiKey: "pending_approval"
  },
  {
    label: "Activated",
    color: "#3F9142",
    apiKey: "activated"
  },
  {
    label: "Deactivated",
    color: "#C62828",
    apiKey: "deactivated"
  }
];

export const createdDateMenuItems = [
  { label: "Last 7 days", value: 7 },
  {
    label: "Last 30 days",
    value: 30
  },
  { label: "Last 60 days", value: 60 },
  { label: "Lifetime", value: "" },
  { label: "Custom", value: "custom" }
];

export const STATUS_COLORS = {
  pending_approval: "#E9A30C",
  deactivated: "#C62828",
  activated: "#3F9142",
  not_filled: "#1f1f1f"
};

export const searchFieldOptions = [
  { label: "First Name", value: "first_name" },
  { label: "Email", value: "email" },
  { label: "Phone Number", value: "phone_number" },
  { label: "Domain", value: "domain" }
];

export const ACTION_COLORS = {
  view: "#6ee7b7",
  search: "#c4b5fd",
  contact: "#fde68a",
  share: "#a5b4fc"
};

export const FALLBACK_COLORS = [
  "#f9a8d4",
  "#fdba74",
  "#67e8f9",
  "#a3e635",
  "#fb923c"
];

export const formatDate = (value) => {
  if (!value) return "-";
  try {
    return format(new Date(value), "MMM dd, yyyy h:mm a");
  } catch {
    return "-";
  }
};
